module.exports = __webpack_public_path__ + "static/media/bgDSR.86e43f4e.png";